<template>
  <div class="card border-0">
    <div class="card-body p-4">
      <div v-if="isDepartmentBreakdown && departmentBreakdown" class="h-100 d-flex flex-column justify-content-around">
        <div v-for="index in 5" :key="index" class="row star-count-row">
          <div class="col-7 col-sm-8 pr-0">
            <span class="star-number">{{ -index + 6 }}</span>
            <div class="progress">
              <div
                class="progress-bar"
                :style="`width: ${(departmentBreakdown[`${-index + 6}_star`] / totalReviewCount) * 100}%;`"
                role="progressbar"
                :aria-valuenow="departmentBreakdown[`${-index + 6}_star`]"
                :aria-valuemin="0"
                :aria-valuemax="totalReviewCount"
              ></div>
            </div>
          </div>
          <div class="col-5 col-sm-4 text-right small text-muted review-count">
            {{ departmentBreakdown[`${-index + 6}_star`] }}
            {{
              departmentBreakdown[`${-index + 6}_star`] === 1
                ? $tc('message.reviews.reviews', 1)
                : $tc('message.reviews.reviews', 0)
            }}
          </div>
        </div>
      </div>
      <div v-else>
        <div class="mt-1 font-weight-bold department-ratings-heading">
          {{ $t('message.reviews.departmentRatings') }}
        </div>
        <template v-for="(score, key, index) in scores">
          <div v-if="score['reviewCount'] > 0 && key !== 'overview'" :key="index" class="row py-sm-1 py-3">
            <div class="col-sm-3 pr-0">
              <span class="department">{{ $t(`message.reviews.${key}`) }}</span>
            </div>
            <div class="col-3 col-sm-2">
              <span class="average">{{ parseFloat(score.rating).toFixed(1) }}</span>
            </div>
            <div class="col-9 col-sm-7 pt-02 pl-0 pl-sm-2 pr-2 pr-sm-3">
              <mobialis-star-bar
                :stacked="false"
                :reviewCount="score.reviewCount"
                :spacing="1"
                :aggregateRating="parseFloat(score.rating)"
                :reviewCountLabel="`${$t('message.DHS.reviews.reviewCount')}`"
              >
                <template v-if="isAVRMobile" slot="subtext">({{ score.reviewCount }})</template>
              </mobialis-star-bar>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepartmentBreakdownCard',
  components: {},
  props: {
    scores: {
      type: Object,
      required: true,
    },
    isDepartmentBreakdown: {
      type: Boolean,
      default: false,
    },
    departmentBreakdown: {
      type: Object,
      required: false,
    },
    totalReviewCount: {
      type: Number,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
.department {
  display: inline-block;
  line-height: 24px;
  margin-top: 4px;
}
.average {
  display: inline-block;
  font-size: 20px;
  line-height: 24px;
  font-weight: bold;
  top: 3px;
  position: relative;
  @media (min-width: 576px) {
    float: right;
  }
}
.pt-02 {
  padding-top: 2px;
}
.star-count-row {
  padding: 3px 0 9px;
  &:last-child {
    padding-bottom: 0;
  }
}
.progress {
  height: 12px;
  border-radius: 6px;
  margin-top: 6px;
  margin-left: 25px;
  .progress-bar {
    background-color: #f5a300;
  }
}
.star-number {
  position: absolute;
}
.review-count {
  margin-top: 2px;
}
.department-ratings-heading {
  text-align: center;
}
@media (min-width: 576px) {
  .card-body {
    min-height: 220px;
  }
  .department-ratings-heading {
    text-align: left;
  }
}
</style>
